import React, { memo } from "react";
import { motion } from "framer-motion";
import Round from "../../Round.svg";

const SAMIntroductionMobile = memo(({ textes }) => {
  return (
    <section id="intro-mobile" className="flex flex-col mt-auto mb-auto justify-start items-center h-[100vh]">
      <div className="relative flex flex-col items-center">
        <motion.img
          src={Round}
          alt="SAM Logo"
          className="absolute flex z-[100] top-[15vh] sm:w-[200px] xs:w-[200px]"
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 6 }}
          exit={{ opacity: 0 }}
        />
        <div className="flex flex-row items-center">
        <h1 className="flex font-sam text-[10rem] ml-[7rem] sm:ml-[12rem] text-white text-center xs:relative xs:mt-[18vh] xs:text-left sm:relative sm:mt-[18vh]  ">SAM</h1>
        
        <div className="flex flex-col relative bottom-[25%] top-[-1vh] xs:bottom-0 xs:top-0 xs:relative xs:mt-[40rem] xs:text-left sm:mt-[32rem] sm:mr-[5rem] sm:text-left sm:bottom-[-10vh] md:mt-[25rem] md:bottom-[25%] lg:mt-[10rem] 3xl:mt-[10rem] leading-4 ">
          <p className="font-lexend text-[1rem] text-sam-cyan m-0 text-left ml-[10px] ]  xs:text-left xs:ml-0  sm:text-left sm:ml-0  md:text-left lg:text-left ">Studio</p>
          <p className="font-lexend text-[1rem] text-sam-cyan m-0 text-left ml-[10px] ]  xs:text-left xs:ml-0  sm:text-left sm:ml-0  md:text-left lg:text-left ">
            <b>animé</b> et 
          </p>
          <p className="font-lexend text-[1rem] text-sam-cyan m-0 text-left ml-[10px] ]  xs:text-left xs:ml-0  sm:text-left sm:ml-0  md:text-left lg:text-left ">
            <b>mouvementé</b>
          </p>
        </div>
        </div>
      </div>
      <div className="flex items-center mt-[10rem] flex-col md:mt-[10rem] md:text-center flex-col-1">
        <p className="font-sam text-[3rem] text-white m-[0_1rem]  xs:text-[3rem]  ">{textes?.mentra1}</p>
        <p className="text-[3rem] text-sam-cyan m-[0_1rem]  xs:text-[1.5rem]  ">&#8226;</p>
        <p className="font-sam text-[3rem] text-white m-[0_1rem]  xs:text-[3rem]  ">{textes?.mentra2}</p>
        <p className="text-[3rem] text-sam-cyan m-[0_1rem]  xs:text-[1.5rem]  ">&#8226;</p>
        <p className="font-sam text-[3rem] text-white m-[0_1rem]  xs:text-[3rem]  ">{textes?.mentra3}</p>
      </div>
    </section>
  );
});

SAMIntroductionMobile.displayName = "SAMIntroductionMobile";

export default SAMIntroductionMobile;
